import React, { useState, useEffect } from 'react';
import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';

const Services = () => {
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const sectionElement = document.getElementById('services');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => setIsInView(entry.isIntersecting));
      },
      { threshold: 0.1 },
    );

    if (sectionElement) observer.observe(sectionElement);

    return () => {
      if (sectionElement) observer.unobserve(sectionElement);
    };
  }, []);

  const sectionStyle = {
    transition: 'opacity 0.5s ease, transform 0.5s ease',
    opacity: isInView ? 1 : 0,
    transform: isInView ? 'translateY(0)' : 'translateY(20px)',
    visibility: isInView ? 'visible' : 'hidden',
  };
  return (
    <section id="services" className="services section" style={sectionStyle}>
      {/* Section Title */}
      <div className="container section-title" data-aos="fade-up">
        <h2>Layanan</h2>
        <p>
          Kami menyediakan layanan kesehatan berkualitas dengan tenaga medis
          profesional dan peralatan modern untuk memastikan kesehatan dan
          kenyamanan Anda.
        </p>
      </div>
      {/* End Section Title */}

      <div className="container">
        <div className="row gy-4">
          <div
            className="col-lg-4 col-md-6"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <div className="service-item position-relative">
              <div className="icon">
                <Icon icon="fa6-solid:bed-pulse" />
              </div>
              <Link to="/bed" className="stretched-link">
                <h3>Ketersediaan Tempat Tidur</h3>
              </Link>
              <p>
                Menampilkan informasi real-time mengenai ketersediaan tempat
                tidur di rumah sakit untuk memudahkan pasien dalam melihat
                kapasitas yang tersedia.
              </p>
            </div>
          </div>

          <div
            className="col-lg-4 col-md-6"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <div className="service-item position-relative">
              <div className="icon">
                <Icon icon="tabler:calendar-time" />
              </div>
              <Link to="/jadwal-dokter" className="stretched-link">
                <h3>Jadwal Dokter</h3>
              </Link>
              <p>
                Memberikan akses cepat kepada pasien untuk melihat jadwal
                praktek dokter yang tersedia di rumah sakit, sehingga mereka
                bisa merencanakan kunjungan dengan lebih baik.
              </p>
            </div>
          </div>

          <div
            className="col-lg-4 col-md-6"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <div className="service-item position-relative">
              <div className="icon">
                <Icon icon="ant-design:form-outlined" />
              </div>
              <Link to="/pendaftaran-online" className="stretched-link">
                <h3>Pendaftaran Online</h3>
              </Link>
              <p>
                Fitur ini memungkinkan pasien untuk mendaftar dan membuat janji
                secara online tanpa perlu mengunjungi rumah sakit, mempercepat
                proses administrasi.
              </p>
            </div>
          </div>

          <div
            className="col-lg-4 col-md-6"
            data-aos="fade-up"
            data-aos-delay="400"
          >
            <div className="service-item position-relative">
              <div className="icon">
                <Icon icon="material-symbols:stethoscope-outline" />
              </div>
              <Link to="/telemedic" className="stretched-link">
                <h3>SI KOMEDO</h3>
              </Link>
              <p>
                Sistem Konsultasi Medis Online (SI KOMEDO) menyediakan layanan
                konsultasi medis secara online, memungkinkan pasien untuk
                berkonsultasi dengan dokter tanpa harus datang langsung ke rumah
                sakit.
              </p>
            </div>
          </div>

          <div
            className="col-lg-4 col-md-6"
            data-aos="fade-up"
            data-aos-delay="500"
          >
            <div className="service-item position-relative">
              <div className="icon">
                <Icon icon="material-symbols:info-outline" />
              </div>
              <Link to="/informasi" className="stretched-link">
                <h3>Informasi</h3>
              </Link>
              <p>
                Menyediakan informasi umum seputar rumah sakit, layanan yang
                ditawarkan, dan fasilitas yang tersedia untuk memudahkan
                pengguna dalam mencari informasi.
              </p>
            </div>
          </div>

          <div
            className="col-lg-4 col-md-6"
            data-aos="fade-up"
            data-aos-delay="600"
          >
            <div className="service-item position-relative">
              <div className="icon">
                <Icon icon="material-symbols:call-log" />
              </div>
              <Link to="/pengaduan" className="stretched-link">
                <h3>Pengaduan</h3>
              </Link>
              <p>
                Fitur pengaduan bagi pasien atau pengunjung rumah sakit untuk
                memberikan feedback atau melaporkan masalah yang dialami,
                sehingga rumah sakit dapat meningkatkan kualitas layanan.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
